import React from 'react';
import Button from '@mui/material/Button';
import clsx from 'clsx';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  isActive?: boolean;
  error?: boolean;
  search?: boolean;
  disabled?: boolean;
  className?: string;
};

function OutlineButton({
  onClick,
  children,
  isActive = false,
  error = false,
  search,
  disabled = false,
  className,
}: Props) {
  const styleClass = clsx(
    '!text-sm !border-gray-200 !text-black !normal-case !font-normal',
    { '!text-populate-green !border-populate-green': isActive },
    { '!text-red-500 !border-red-500 ': error },
    { '!text-populate-green !border-populate-green ': search },
    className,
  );
  return (
    <Button
      className={styleClass}
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

export default OutlineButton;
